// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Da5--0EUrC75Phdsp8tVK"};